
try {
(function($, RAF) {

    var $body = $('body'),
        phone = $('head > meta[name="phone"]').attr('content') || '+31 (0)6 25 14 06 28';

    var $mobile = $('#navbar-mobile');

    RAF(function() {
        $('.navbar-nav').first().addClass('navbar-nav-pc');

        /*$('label', $('#navbar-mobile')).each(function(index, el) {
            var f = $(el).attr('for');
            if (f) {
                var for_m = f + '-m';
                $(el).attr('for', for_m);
                $('input[id="' + f + '"]', $(el).parent()).attr('id', for_m);
            }
        });*/

        $('input[type="checkbox"]', $mobile).on('change', function() {

            var updated = $(this);
            if (updated.hasClass('updating')) {
                return;
            }

            RAF(function() {

                $('input[type="checkbox"]', $mobile)
                    .not(updated)
                    .each(function(index, el) {

                        console.log(4,$(el).attr('id'))
                        if ($(el).attr('id') === updated.attr('id')) {
                            return;
                        }
                        $(el).addClass('updating');
                        $(el).prop('checked', false);
                        $(el).removeClass('updating');

                        console.log('222', el)
                        $(el).next('ul').hide();
                    });

                if (updated.is(':checked')) {
                    updated.next('ul').show();
                } else {
                    updated.next('ul').hide();
                }
            });

        });

        $mobile.on('click', function(e) {
            e.stopPropagation();
        });

        var wwk_moved;
        var move_wwk = function() {
            if (!wwk_moved && $('.wwk--sidebar-mobile').length && $('.wwk--sidebar-mobile .wwk--rating').html()) {
                wwk_moved = true;
                if (wwk_move_interval) {
                    clearInterval(wwk_move_interval);
                }
                RAF(function() {
                    $('#navbar-mobile li.wwk a.wwk .r').html($('.wwk--sidebar-mobile .wwk--rating').html());
                    $('.wwk--sidebar-mobile').remove();
                });
            }
        }

        var reset_menu = function() {

            $('input[type="checkbox"]', $mobile).each(function(index, el) {

                var open = $(el).is(':checked');
                $(el).prop('checked', false);

                if (open) {
                    $(el).next('ul').hide();
                }
            });

            closeTimeout = setTimeout(function() {
                RAF(function() {
                    $('#menublackbg').stop().hide();

                    $mobile.css('visibility', 'hidden');
                });
            }, 500);
        }

        var wwk_move_interval = setInterval(move_wwk, 500);

        var closeTimeout;
        $('.nav-toggle').on('change', function() {
            var el = $(this);
            RAF(function() {

                if (closeTimeout) {
                    clearTimeout(closeTimeout);
                    closeTimeout = false;
                }

                if (el.is(':checked')) {
                    $mobile.css('visibility', 'visible');

                    if ($('#menublackbg').length === 0) {
                        $body.prepend('<div id="menublackbg" style="display:none;"></div>');
                    }
                    $('#menublackbg').stop().fadeIn(200);

                    move_wwk();

                } else {

                    $('#menublackbg').stop().fadeOut(200);
                    reset_menu();
                }
            });
        });

        $body.on('click', '#menublackbg', function(e) {
            $('#menublackbg').hide();

            $('.nav-toggle').prop('checked', false);
            reset_menu();
        });

        $('.nav-toggle').next('span.sr-only').on('click', function(e) {
            $('.nav-toggle').prop('checked', !$('.nav-toggle').prop('checked'));
        });

    });

})(jQuery, window.RAF);
} catch(e){_st_catch(e)}
